var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCashOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 31.5L44 31.5C44.8284 31.5 45.5 30.8284 45.5 30V9C45.5 8.17157 44.8284 7.5 44 7.5L5 7.5C4.17157 7.5 3.5 8.17157 3.5 9V30C3.5 30.8284 4.17157 31.5 5 31.5Z",
    stroke: "#718CC8",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 36H42.5M9.5 40.5H39.5",
    stroke: "#718CC8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 27C28.6421 27 32 23.6421 32 19.5C32 15.3579 28.6421 12 24.5 12C20.3579 12 17 15.3579 17 19.5C17 23.6421 20.3579 27 24.5 27Z",
    stroke: "#718CC8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 15C43.5109 15 41.6032 14.2098 40.1967 12.8033C38.7902 11.3968 38 9.48912 38 7.5M3.5 15C4.48491 15 5.46018 14.806 6.37013 14.4291C7.28007 14.0522 8.10686 13.4997 8.8033 12.8033C9.49974 12.1069 10.0522 11.2801 10.4291 10.3701C10.806 9.46018 11 8.48491 11 7.5M45.5 24C43.5109 24 41.6032 24.7902 40.1967 26.1967C38.7902 27.6032 38 29.5109 38 31.5M3.5 24C4.48491 24 5.46018 24.194 6.37013 24.5709C7.28007 24.9478 8.10686 25.5003 8.8033 26.1967C9.49974 26.8931 10.0522 27.7199 10.4291 28.6299C10.806 29.5398 11 30.5151 11 31.5",
    stroke: "#718CC8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashOutline);
export default __webpack_public_path__ + "static/media/cash-outline.ea606c0933cff0c8fc40312bf924ef72.svg";
export { ForwardRef as ReactComponent };